export const SESSION_GRACE_DIALOG_TIME = 60; // grace time to show dialog
export const SESSION_GRACE_REFRESH_TIME = 5; // grace time left to refresh token
